import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import {
  LessonMappingResult,
  LessonMappingTreeData,
} from 'components/contentService/types'
import { stringOrNumberSort } from 'components/Helpers'
import { Table } from 'shared/ui/Table/Table'
import { Column } from 'shared/ui/Table/types'
import { nodePathString } from 'components/tree/utility/utility'

export function LessonMappingsResultView({
  data,
}: {
  data: LessonMappingResult
}) {
  return (
    <Box>
      <NotFound data={data.not_found} />
      <StandardsData
        standardsData={data.standards_data}
        treeData={data.tree_data}
      />
    </Box>
  )
}

function NotFound({ data }: { data: string[] }) {
  if (!data.length) return null
  return <Box>{`${data.length} standard ids not found`}</Box>
}

function StandardsData({
  standardsData,
  treeData,
}: {
  standardsData: Record<string, string[]>
  treeData: LessonMappingTreeData
}) {
  const tableRows = useMemo(() => {
    return Object.keys(standardsData)
      .sort(stringOrNumberSort)
      .reduce<{ standardName: string; lessonId: string }[]>(
        (acc, standardName) => {
          standardsData[standardName].forEach((lessonId) => {
            acc.push({ standardName, lessonId })
          })
          return acc
        },
        [],
      )
  }, [standardsData])

  const cols = useMemo<Column<{ standardName: string; lessonId: string }>[]>(
    () => [
      { title: 'Standard Name', rowContent: (r) => r.standardName },
      {
        title: 'Tree',
        rowContent: (r) => {
          const [treeId, versionId] = r.lessonId.split(':')
          return treeData[[treeId, versionId].join(':')]?.title
        },
      },
      {
        title: 'Lesson',
        rowContent: (r) => {
          return treeData[r.lessonId]?.title
        },
      },
      {
        title: 'Lesson Path',
        rowContent: (r) => {
          return nodePathString(treeData[r.lessonId]?.node_path)
        },
      },
    ],
    [treeData],
  )

  return (
    <Box>
      <Table columns={cols} items={tableRows} />
    </Box>
  )
}
